<template>
  <q-card flat class="dropbox-embed">
    <q-inner-loading :showing="this.loading">
      <q-spinner size="50px" color="secondary" />
      <div class="app-loader-text">Please wait...</div>
    </q-inner-loading>
    <q-card-section class="dropbox-embed__content">
      <div class="dropbox-embed__iframe" ref="DropboxEmbed" v-if="this.embed" />
      <div class="dropbox-embed__error" v-else>
        Sorry your browser does not support this feature, please use the button
        below to go to the Dropbox folder.
        <q-btn
          class="q-ma-md"
          icon-right="launch"
          unelevated
          color="secondary"
          label="Go to Dropbox"
          :href="url"
          type="a"
          target="_blank"
        />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  props: { url: String },
  data() {
    return {
      embed: Object,
      loading: true,
    };
  },
  mounted() {
    // Added Dropbox to package.json > eslintConfig > globals
    var options = {
      // Shared link to Dropbox file
      link: this.url,
      file: {
        // Sets the zoom mode for embedded files. Defaults to 'best'.
        zoom: "fit", // or "fit"
      },
      folder: {
        // Sets the view mode for embedded folders. Defaults to 'list'.
        view: "list", // or "grid"
        headerSize: "small", // or "small"
      },
    };

    if (Dropbox && Dropbox.isBrowserSupported()) {
      this.embed = Dropbox.embed(options, this.$refs.DropboxEmbed);
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  },
  unmounted() {
    Dropbox.unmount(this.embed);
  },
  // Prevent Memory Leak
  beforeDestroy() {
    Dropbox.unmount(this.embed);
  },
};
</script>

<style lang="scss">
.dropbox-embed {
  width: 100%;
  height: 100%;
  &__content {
    border: 0;
    width: inherit;
    height: inherit;
    overflow: hidden;
  }
  &__error {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__iframe {
    width: inherit;
    height: inherit;
  }
}
</style>
